import axios from 'axios';

const state = () => ({
  minAppVersion: '0.0.0',
});

const getters = {
  getCurrentVersion: () => {
    return localStorage.getItem('cached_app_version') || '0.0.0';
  },
  getMinAppVersion(state) {
    return state.minAppVersion;
  },
};

const mutations = {
  setMinimumAppVersion(state, minVersion) {
    state.minAppVersion = minVersion;
  },
};

const actions = {
  async fetchMinimumAppVersion({ commit }) {
    try {
      const response = await axios.get(process.env.VUE_APP_API_URL + '/cms/app-version');
      if (response.data && response.data.appVersion) {
        commit('setMinimumAppVersion', response.data.appVersion);
      } else {
        console.warn('app version field missing');
      }
    } catch (e) {
      console.warn(e);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
